$(function() {  
  $("#WhitepaperEmail").on("submit", function(e) {
    var $this = $(this),
    inputs = $this.find("input, button"),
    submit = inputs.filter("input[type=submit], button[type=submit]"),
    loading = $this.find(".loading-indicator"),
    validation = $this.find(".validation").empty().hide(),
    captchaValidation = $this.find(".captchaValidation").empty().hide();
    widgetId1 = null;
    var recatpchaCallback = function(data)
    {
      $("#token").val(data);
      $this.unbind('submit');
      submit.trigger('click');
    }
   
    recaptchaVersion = $this.find("#recaptchaVersion").val();
   
    e.preventDefault();
    if(recaptchaVersion === "V2") {
      widgetId1 = grecaptcha.render('recaptchaCMIEmailV2', {
        'sitekey' : grecaptchav2_sitekey,
        'callback' : recatpchaCallback
      });
    } else {
      if ($this.valid()) { 
        grecaptcha.ready(function() {
          grecaptcha.execute(grecaptchav3_sitekey, {action: 'whitepaper'}).then(function(token) {
            $("#token").val(token);
            $this.unbind('submit');
            submit.trigger('click');
          });
        });
      }
    }
    return false;
  });
  
});
